import React from 'react';
import { Skeleton } from '@routific/hive';
import styled from 'styled-components';
import { TFunction } from 'i18next';
import { RouteTimelineDtoModelType } from '../../../../../../store/mst/models';
import { HeaderEllipsisCaption, HeaderTextStack } from './HeaderTextStyles';
import { getEventTimeLabel } from './getEventTimeLabel';

interface Props {
  address: string | null | undefined;
  labeledTimeDisplay?: string;
  isLoading: boolean;
}

const AddressSkeleton = styled(Skeleton)`
  flex: 1;
  min-width: 0;
  .ant-skeleton-content { height: 16px; }
  .ant-skeleton-title { height: 14px; margin: 0; }
`;

export const getLabeledTimeDisplay = (
  event: RouteTimelineDtoModelType,
  t: TFunction,
): string => {
  const timeValue = event.isDeparted ? event.endTimeString : event.startTimeString;
  if (!timeValue) return '';

  return `${getEventTimeLabel(event, t)}: ${timeValue}`;
};

const StopCardHeader: React.FC<Props> = ({ address, labeledTimeDisplay, isLoading }) => (
  <HeaderTextStack
    data-testid="visit-timeline-card-header"
    data-cy="visit-timeline-card-header"
  >
    {labeledTimeDisplay ? (
      <HeaderEllipsisCaption type="secondary">{labeledTimeDisplay}</HeaderEllipsisCaption>
    ) : null}
    {isLoading ? (
      <div data-testid="stop-card-header-skeleton">
        <AddressSkeleton active paragraph={false} title={{ width: '75%' }} />
      </div>
    ) : (
      <HeaderEllipsisCaption ellipsis>{address ?? ''}</HeaderEllipsisCaption>
    )}
  </HeaderTextStack>
);

export default StopCardHeader;
